import * as React from 'react';
import { List as AntList } from 'antd';

export type ListItemProps = {
  // TODO
};

const ListItem = (props: ListItemProps & React.ComponentProps<typeof AntList.Item>) => {
  return <AntList.Item {...props} />;
};

ListItem.defaultProps = {
  // TODO
};

export default ListItem;
